"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelQueryFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const QueryFieldKey_1 = __importDefault(require("../QueryFieldKey"));
exports.ModelQueryFields = {
    [QueryFieldKey_1.default.OPDEFINITION]: {
        key: QueryFieldKey_1.default.OPDEFINITION,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        label: () => lib_i18n_1.default.t('op-definition'),
    },
    [QueryFieldKey_1.default.OP]: {
        key: QueryFieldKey_1.default.OP,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        label: () => lib_i18n_1.default.t('op'),
    },
    [QueryFieldKey_1.default.OPDEFINITION_HIDDEN]: {
        key: QueryFieldKey_1.default.OPDEFINITION,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        label: () => lib_i18n_1.default.t('op-definition'),
        hidden: true,
        veryHidden: true,
    },
    [QueryFieldKey_1.default.ORGANISATION]: {
        key: QueryFieldKey_1.default.ORGANISATION,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        label: () => lib_i18n_1.default.t('organisation'),
    },
    [QueryFieldKey_1.default.PLACE]: {
        key: QueryFieldKey_1.default.PLACE,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        label: () => lib_i18n_1.default.t('place'),
    },
    [QueryFieldKey_1.default.POSITION]: {
        key: QueryFieldKey_1.default.POSITION,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        label: () => lib_i18n_1.default.t('position'),
    },
    [QueryFieldKey_1.default.STAFF]: {
        key: QueryFieldKey_1.default.STAFF,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        label: () => lib_i18n_1.default.t('staff'),
    },
    [QueryFieldKey_1.default.TEAM]: {
        key: QueryFieldKey_1.default.TEAM,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        label: () => lib_i18n_1.default.t('team'),
    },
    [QueryFieldKey_1.default.TEMPLATE]: {
        key: QueryFieldKey_1.default.TEMPLATE,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        label: () => lib_i18n_1.default.t('template'),
    },
    [QueryFieldKey_1.default.TEMPLATE_SOURCE]: {
        key: QueryFieldKey_1.default.TEMPLATE_SOURCE,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('source'),
    },
    [QueryFieldKey_1.default.TEMPLATE_CATEGORY]: {
        key: QueryFieldKey_1.default.TEMPLATE_CATEGORY,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('category'),
    },
    [QueryFieldKey_1.default.INDUSTRY]: {
        key: QueryFieldKey_1.default.INDUSTRY,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        label: () => lib_i18n_1.default.t('industry'),
    },
};
exports.default = exports.ModelQueryFields;
